import React from "react";
import SEO from "../components/SEO";
import { PageHero, SectionHeading } from "../components/ui-blocks";
import { company } from "../mock/mock";

export default function PrivacyPolicy() {
  const sections = [
    { title: "Information We Collect", body: "We collect information you provide directly — such as your name, practice name, email, phone number and message — when you submit a form or contact us. We also collect standard usage data (like pages visited) to improve our website experience." },
    { title: "How We Use Information", body: "We use the information you provide to respond to inquiries, schedule audits and consultations, deliver our services and improve our website. We do not sell your personal information." },
    { title: "Cookies", body: "We use cookies to analyze website traffic and optimize your experience. By accepting our use of cookies, your data may be aggregated with other user data. You can decline cookies through your browser settings." },
    { title: "Protected Health Information", body: "Any protected health information (PHI) handled during our services is treated in accordance with our HIPAA-conscious workflows and secure data-handling processes." },
    { title: "Data Sharing", body: "We share information only with trained, authorized team members and trusted service providers as necessary to deliver our services, and as required by law." },
    { title: "Contact", body: `For any privacy questions, contact us at ${company.email} or ${company.phone}.` },
  ];
  return (
    <>
      <SEO title="Privacy Policy" description="VerifiAssist privacy policy — how we collect, use and protect your information." path="/privacy-policies" />
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="How we collect, use and protect the information you share with us." />
      <section className="container-x py-16 sm:py-20">
        <div className="mx-auto max-w-3xl space-y-8">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="text-xl font-bold text-brand-navy">{s.title}</h2>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
